module.exports = __webpack_public_path__ + "img/insta.4d3b8b3.svg";